<mat-dialog-content id="dialog-content">
  @if (showSelection && !showInputBox) {
    <div>
      {{ data.loginConfig?.whatTypeInstructionText || 'What type of user are you?' }}
    </div>
  }
  @if (!showSelection && showInputBox) {
    <div>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>UserName/Barcode </mat-label>
        <input
          matInput
          #userInput
          type="text"
          placeholder="Enter Username/Barcode"
          name="userName"
          [(ngModel)]="userName"
        />
      </mat-form-field>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (showSelection && !showInputBox) {
    <button
      mat-button
      role="button"
      [disabled]="submitting"
      aria-label="Submit Patron"
      type="submit"
      (click)="submit('patron')"
    >
      {{ data.loginConfig?.whatTypePatronLabel || 'Patron' }}
    </button>
    <button
      mat-button
      role="button"
      [disabled]="submitting"
      aria-label="Submit Staff"
      type="button"
      (click)="submit('staff')"
    >
      {{ data.loginConfig?.whatTypeStaffLabel || 'Staff' }}
    </button>
  }

  @if (!showSelection && showInputBox) {
    <button
      mat-button
      [disabled]="submitting"
      role="button"
      aria-label="Submit Staff"
      autocomplete="off"
      type="button"
      (click)="submitUserName()"
    >
      @if (!submitting) {
        Submit
      }
      @if (submitting) {
        <mat-icon>
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
      }
    </button>
    <button
      mat-button
      role="button"
      aria-label="Go Back"
      type="button"
      (click)="goBack()"
      [disabled]="submitting"
    >
      Go Back
    </button>
  }
</mat-dialog-actions>
